import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import CreateEmpresas from "../../clientes/Empresas/Create.js"

import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fechaContacto: new Date(),
            empresa_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            empresa_id: data.empresa_id
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.contactos.edit}
                postUrl={api.proyectos.contactos.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Contacto ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Contacto"}
                buttonTitle={"Editar Contacto"}
                buttonIcon={"fa fa-pencil fa-lg"}

                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}>
                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Fecha de Contacto</Label>
                    </Col>
                    <Col className="col-8">
                        <Datetime
                            className="display-inline-block"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            closeOnSelect={true}
                            inputProps={{ name: 'fechaContacto' }}
                            value={this.state.fechaContacto}
                            onChange={(e) => this.setState({ fechaContacto: e._d })}
                        />
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Empresa/Organización</Label>
                    </Col>
                    <Col className="col-8">
                        <ParadigmaAsyncSeeker Create={CreateEmpresas} fieldName={"empresa_id"}
                            url={api.clientes.empresas.select} value={this.state.empresa_id}
                            onChange={(value) => this.setState({ empresa_id: value.pk })}
                        />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Email</Label>
                    </Col>
                    <Col className="col-8">
                        <Input type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Teléfono</Label>
                    </Col>
                    <Col className="col-8">
                        <Input type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input rows={10} type="textarea" name="observaciones" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Creado por</Label>
                    </Col>
                    <Col className="col-8">
                        <Input disabled={true} type="text" name="user" />
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento0/Edit.js